import { baseApi } from './base';
import type { BillableItem, GenerateInvoiceRequest, GeneratedInvoiceResponse, Invoice } from '@/types/billing';

export const billingService = {
  async getBillables(params: { client?: string; lawsuit?: string; }): Promise<BillableItem[]> {
    const queryParams: Record<string, string> = {};
    if (params.client) {
      queryParams.client = params.client;
    }
    if (params.lawsuit) {
      queryParams.lawsuit = params.lawsuit;
    }
    const query = new URLSearchParams(queryParams).toString();
    const endpoint = query ? `/billing/billables/?${query}` : '/billing/billables/';
    return baseApi.request<BillableItem[]>(endpoint);
  },

  async getInvoices(params: { client?: string; lawsuit?: string; limit?: number; offset?: number; ordering?: string; } = {}): Promise<{ results: Invoice[], count: number }> {
    const queryParams: Record<string, string> = {};
    if (params.client) queryParams.client = params.client;
    if (params.lawsuit) queryParams.lawsuit = params.lawsuit;
    if (params.limit !== undefined) queryParams.limit = params.limit.toString();
    if (params.offset !== undefined) queryParams.offset = params.offset.toString();
    if (params.ordering) queryParams.ordering = params.ordering;
    
    const query = new URLSearchParams(queryParams).toString();
    const endpoint = query ? `/billing/invoices/?${query}` : '/billing/invoices/';
    
    // Incase the API is not returning paginated data yet, we handle arrays fallback
    const response = await baseApi.request<any>(endpoint);
    if (Array.isArray(response)) {
      return { results: response, count: response.length };
    }
    return response as { results: Invoice[], count: number };
  },

  async getInvoice(id: string): Promise<Invoice> {
    return baseApi.request<Invoice>(`/billing/invoices/${id}/`);
  },

  async generateInvoice(data: GenerateInvoiceRequest): Promise<GeneratedInvoiceResponse> {
    return baseApi.request<GeneratedInvoiceResponse>('/billing/generate-invoice/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async updateBillableItem(id: string, data: Partial<BillableItem>): Promise<BillableItem> {
    return baseApi.request<BillableItem>(`/billing/billables/${id}/`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  async nextInvoiceNumber(): Promise<{ suggested_number: string }> {
    return baseApi.request<{ suggested_number: string }>(
      '/billing/next-invoice-number/'
    );
  },

  async cancelInvoice(id: string): Promise<void> {
    return baseApi.request<void>(
      `/billing/invoices/${id}/cancel-invoice/`,
      { method: 'POST' }
    );
  },
};